/**
 * The browser's own file dialog, standing in for the workspace picker Kaoto asks for when it runs
 * inside an IDE. Each chosen file comes back by name with its text; closing the dialog chooses
 * nothing.
 */
const readText = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result ?? ''));
    reader.onerror = () => reject(reader.error ?? new Error(`Could not read ${file.name}.`));
    reader.readAsText(file);
  });

export const pickFiles = (include: string, many: boolean): Promise<Record<string, string>> =>
  new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.multiple = many;
    /* Kaoto asks with a glob such as `**\/*.{xsd,json}`; the dialog wants `.xsd, .json`. */
    const extensions = /\{([^}]*)\}/.exec(include)?.[1]?.split(',');
    if (extensions?.length) input.accept = [...new Set(extensions.map((item) => `.${item.toLowerCase()}`))].join(', ');
    input.style.display = 'none';
    const done = (files: Record<string, string>) => {
      input.remove();
      resolve(files);
    };
    input.addEventListener('cancel', () => done({}));
    input.addEventListener('change', async () => {
      const chosen = Array.from(input.files ?? []);
      const read = await Promise.allSettled(chosen.map(async (file) => [file.name, await readText(file)] as const));
      done(Object.fromEntries(read.flatMap((item) => (item.status === 'fulfilled' ? [item.value] : []))));
    });
    document.body.append(input);
    input.click();
  });
